<template>
    <div>
        <!-- Start -->
        <section class="relative bg-indigo-600/5">
            <div class="container-fluid relative">
                <div class="grid grid-cols-1">
                    <div class="flex flex-col min-h-screen justify-center md:px-10 py-10 px-4">
                        <div class="title-heading text-center my-auto">
                            <img src="/images/error.svg" class="h-52 mx-auto" alt="">
                            <h1 class="mt-10 mb-4 md:text-4xl text-3xl font-bold">{{ title }}</h1>
                            <p class="text-slate-400"> {{ description }} </p>

                            <div class="mt-4">
                                <a :href="route('home')" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md">Back to Home</a>
                            </div>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- End -->

    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
export default {
    layout: Layout,
    props: {
        status: Number,
    },
    computed: {
        title() {
            return {
                503: '503: Service Unavailable',
                500: '500: Server Error',
                404: '404: Page Not Found',
                403: '403: Forbidden',
            }[this.status]
        },
        description() {
            return {
                503: 'Sorry, we are doing some maintenance. Please check back soon.',
                500: 'Whoops, something went wrong on our servers.',
                404: 'Sorry, the page you are looking for could not be found.',
                403: 'Sorry, you are forbidden from accessing this page.',
            }[this.status]
        },
    },
}
</script>
